
	 
    import { Options, Vue  } from "vue-class-component";   
    import { Prop } from 'vue-property-decorator'; 
    @Options({
        name: "CardRh",
        components: {   },  
    }) 
    export default class CardRh extends Vue {
          
        @Prop( ) readonly processando!: any
        @Prop( ) readonly titulo!: any  
    }
	 
